import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Form, Input, Button, Typography, message } from "antd";
import { ROW_JUSTIFY, COL_SPAN, ENTER_ORG_TYPE } from "../common/const";
import API from "../config/api";
import {
  PostTeamCreate,
  PostTeamJoin,
  CreateFeloTeam,
} from "../config/request";
import {
  loginClient,
  OpenBrowserUrl,
  getRedirectUrl,
  addUrlParam,
  openRedirectUrl,
  CheckSystem,
} from "../common/globalFun";
import { useIntl } from "react-intl";

import HeaderLogo from "../components/HeaderLogo";
import PageBg from "../components/PageBg";
import PageHeaderComponents from "../components/PageHeader";
import { FELO_IM_URL } from "../common/const";
import * as GA4Tracker from "../common/GA4Tracker";

import "./css/style.css";

const { Title } = Typography;

const CreateTeam = (props) => {
  const { history } = props;
  const intl = useIntl();
  const [form] = Form.useForm();
  const validateMessages = {
    required: "",
  };

  const [loading, setLoading] = useState(false);
  const [enterOrgType, setEnterOrgType] = useState();
  const [isFromClient, setIsFromClient] = useState(false);

  const getDefaultTeamName = () => {
    let name = props.email;
    if (props.account) {
      name = props.account;
    }

    if (name && name.indexOf("@") !== -1) {
      const nameArr = name.split("@");
      name = nameArr[0];
    }

    return intl.formatMessage({ id: "org.of.the.name" }, { name: name });
  };

  const createTeam = async (name) => {
    setLoading(true);

    CreateFeloTeam({ name })
      .then((rsp) => {
        const { loginKey } = rsp;
        if (props.redirectUri) {
          const newHref = addUrlParam(props.redirectUri, {
            loginKey: loginKey,
            isRegister:true
          });
          openRedirectUrl(newHref);
        } else {
          loginClient(loginKey);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const submit = (values) => {
    let { name, inviteCode } = values;
    if (enterOrgType == ENTER_ORG_TYPE.JOINCODE) {
      inviteCode = inviteCode.trim();
      joinOrg(inviteCode);
    } else {
      if (isFromClient && !name) return;
      name = name ? name.trim() : getDefaultTeamName();
      if (isFromClient) {
        createTeam(name);
      } else {
        teamInit(name);
      }
    }
  };

  const teamInit = async (name) => {
    setLoading(true);
    PostTeamCreate({
      account: props.email,
      teamName: name,
    })
      .then((rsp) => {
        if (rsp) {
          props.setGlobalCorpName(name);
          if (rsp.info) {
            const { corpId, reloginKey } = rsp.info;
            props.setGlobalCorpId(corpId);
            props.setGlobalLoginKey(reloginKey);
          }
          if (rsp.certificate) {
            const { team } = rsp.certificate;
            props.setGlobalCorpId(team.team_id);
          }
          if (rsp.login_key) {
            props.setGlobalLoginKey(rsp.login_key);
          }
        }
        history.push("/invite");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const joinOrg = async (invite_code) => {
    setLoading(true);

    PostTeamJoin({
      account: props.email,
      invite_code: invite_code,
      isFromClient: isFromClient,
    })
      .then((rsp) => {
        if (CheckSystem.Felo()) {
          const { loginKey, login_key } = rsp;
          props.setGlobalLoginKey(loginKey || login_key);
          history.push("/download");
        } else {
          OpenBrowserUrl(getRedirectUrl());
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const { data } = props.location;
    if (data && data.enterOrgType) {
      setEnterOrgType(data.enterOrgType);
      setIsFromClient(!!data.isFromClient);
      if (data.enterOrgType === ENTER_ORG_TYPE.JOINCODE) {
        GA4Tracker.customEvent("createTeam", "join_organization");
      } else {
        GA4Tracker.customEvent("createTeam", "Create_organization");
      }
    }
  }, []);

  useEffect(() => {
    if (!form || isFromClient) return;
    if (enterOrgType == ENTER_ORG_TYPE.CREATE) {
      const defaultName = getDefaultTeamName();
      form.setFieldsValue({ name: defaultName });
    }
  }, [form, enterOrgType]);

  /**
   * Dom
   */
  const submitText = () => {
    let text;
    switch (enterOrgType) {
      case ENTER_ORG_TYPE.CREATE:
        text = intl.formatMessage({ id: "create" });
        break;
      case ENTER_ORG_TYPE.JOINCODE:
        text = intl.formatMessage({ id: "join" });
        break;
      default:
        text = intl.formatMessage({ id: "next" });
        break;
    }
    return text;
  };

  // useEffect(() => {
  //   // 如果用户在当前页面刷新的话，就会丢失内存中的email数据，进而导致接口报错。
  //   // 所以如果用户刷新，监测到后跳转到首页。
  //   if (!props.email) {
  //     window.location.href = FELO_IM_URL;
  //   }
  // }, [props]);

  return (
    <>
      <PageHeaderComponents className={["page-header"]} title=" " />
      <PageBg className={[isFromClient ? "hide" : ""]} />
      <Row
        justify={ROW_JUSTIFY}
        align="middle"
        className={`height-full creatge-team-page`}
      >
        <Col span={COL_SPAN}>
          <section className={`hd-section createTeamHead`}>
            <HeaderLogo />
            <Title level={2} hidden={isFromClient}>
              {intl.formatMessage({ id: "create.team.title" })}
            </Title>
          </section>

          <Title
            level={3}
            hidden={!(isFromClient && enterOrgType == ENTER_ORG_TYPE.CREATE)}
          >
            {intl.formatMessage({ id: "create.team.name" })}
          </Title>

          <Title
            level={3}
            hidden={!(isFromClient && enterOrgType == ENTER_ORG_TYPE.JOINCODE)}
          >
            {intl.formatMessage({ id: "label.join.invite.code" })}
          </Title>

          <Form
            form={form}
            onFinish={submit}
            validateMessages={validateMessages}
          >
            {enterOrgType == ENTER_ORG_TYPE.CREATE && (
              <>
                <Title level={5} hidden={isFromClient}>
                  {intl.formatMessage({ id: "create.team.name.now" })}
                </Title>

                <Form.Item
                  name="name"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input
                    autoFocus
                    placeholder={intl.formatMessage({ id: "name" })}
                    size="large"
                  />
                </Form.Item>
              </>
            )}

            {enterOrgType == ENTER_ORG_TYPE.JOINCODE && (
              <>
                <Title level={5} hidden={isFromClient}>
                  {intl.formatMessage({ id: "label.join.invite.code" })}
                </Title>

                <Form.Item
                  name="inviteCode"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input
                    autoFocus
                    placeholder={intl.formatMessage({ id: "invite.code" })}
                    size="large"
                  />
                </Form.Item>
              </>
            )}

            <Form.Item>
              <div
                className={`margin-center ${isFromClient ? "mt-10" : "mt-20"}`}
              >
                <Button
                  loading={loading}
                  block
                  size="large"
                  type="primary"
                  htmlType="submit"
                  g-action={`${
                    enterOrgType === ENTER_ORG_TYPE.JOINCODE
                      ? "join(organization)"
                      : "Create(organization)"
                  }`}
                  g-category="login"
                >
                  {submitText()}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  );
};

const stateProps = (state) => {
  return {
    email: state.email,
    account: state.account,
    token: state.token,
    redirectUri: decodeURIComponent(state.redirectUri),
  };
};

const dispatchProps = (dispatch) => ({
  setGlobalLoginKey: (key) => {
    dispatch({
      type: "setLoginKey",
      value: key,
    });
  },
  setGlobalCorpId: (id) => {
    dispatch({
      type: "setCorpId",
      value: id,
    });
  },
  setGlobalCorpName: (name) => {
    dispatch({
      type: "setCorpName",
      value: name,
    });
  },
});

export default connect(stateProps, dispatchProps)(CreateTeam);